import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

const Navbar = () => {
  const navigate=useNavigate();
  const regName = localStorage.getItem("regName") || "User";
  const branchName = localStorage.getItem("branchName") || "";
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <nav
      className="navbar navbar-expand-lg fixed-top"
      style={{
        background: "linear-gradient(to right, #0d6efd, #0dcaf0)",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        padding: "10px 15px",
      }}
    >

      <div className="container-fluid">

        {/* Brand */}
        <NavLink
          to="/home" className="navbar-brand text-white d-flex align-items-center" >
            <Icon.HouseFill size={24} />
          <span className="fw-bold">
            MIS Dashboard
          </span>
        </NavLink>

          <div className="ms-auto d-flex align-items-center gap-2">

            {/* User Info */}
            <div
              className="d-none d-lg-flex align-items-center bg-white px-3 py-1 rounded-pill shadow-sm"
              style={{ fontSize: "14px" }}
            >
              <Icon.PersonCircle className="me-2 text-primary" />
              <span className="fw-semibold text-dark"> {regName} </span>
              <span className="text-muted ms-1"> @{branchName} </span>
            </div>

            {/* Settings */}
            {user?.userType=='S'
              ?
              <button className="btn btn-primary btn-sm fw-semibold rounded-pill shadow-sm"
              onClick={() => navigate(`userSettingsMIS`)}
              >
                <Icon.GearFill className="me-1" />
              </button>
              :""
            }

            {/* Logout */}
              <button className="btn btn-danger btn-sm fw-semibold rounded-pill shadow-sm"
              onClick={() => navigate(`/`)}
              >
                <Icon.BoxArrowRight className="me-1" />
                Logout
              </button>

          </div>

      </div>

    </nav>
  );
};

export default Navbar;